import MandatoryLogin from './mandatoryLogin';
import MandatoryLoginConfig from './mandatoryLogin.config';

export {
    MandatoryLoginConfig as config,
    MandatoryLogin as default
};



// WEBPACK FOOTER //
// ./lib/js/modules/mandatoryLogin/index.js